import React from 'react';

import ToC from 'Components/ToC';

import { ClassroomDrawer } from '../Components';

const CourseToCPanel = ({
  toggleComponent,
  onToggleComponentClick,
  drawerProps,
  title,
  isOpen,
  ...restProps
}) => {
  return (
    <ClassroomDrawer
      isOpen={isOpen}
      drawerProps={drawerProps}
      title={title}
      toggleComponent={toggleComponent}
      onToggleComponentClick={onToggleComponentClick}
    >
      <ToC {...restProps} />
    </ClassroomDrawer>
  );
};

CourseToCPanel.propTypes = {
  ...ClassroomDrawer.propTypes,
};

export default CourseToCPanel;
